import { Container, Stack } from '@mantine/core';
import PageTitle from 'components/PageTitle';
import PAGES from 'constant/pages';
import { useAppName } from 'contexts/AppProvider';
import TableCourseCombineTNA from 'modules/pages/lcms/courseCombineTNA/TableCourseCombineTNA';
import React from 'react';

const CourseCombinePage = () => {
  const { appName } = useAppName();

  return (
    <Container fluid>
      <Stack>
        <PageTitle
          title={PAGES[appName]?.lcmsCourseCombine?.title || ''}
          description={PAGES[appName]?.lcmsCourseCombine?.description || ''}
        />
        <TableCourseCombineTNA />
      </Stack>
    </Container>
  );
};

export default CourseCombinePage;
